"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = exports.Content = exports.CloseButtonContainer = exports.Header = exports.ScrollYBox = exports.Body = exports.Overlay = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _breakpointObserver = require("@decisiv/breakpoint-observer");

var _designTokens = require("@decisiv/design-tokens");

var _dynamicModifiers = require("../../utils/dynamicModifiers");

var _styleModifiers = require("../../utils/styleModifiers");

var _Flex = _interopRequireDefault(require("../Flex"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function withIcon() {
  return (0, _styledComponents.css)(["", ";"], (0, _dynamicModifiers.applyDynamicModifiers)('hasIcon', function (_ref) {
    var hasIcon = _ref.hasIcon,
        size = _ref.size;

    if (hasIcon) {
      if (size === _breakpointObserver.sizes.XS) {
        return (0, _styledComponents.css)(["padding-left:", "px;"], _designTokens.spacing.base * 2 + 42);
      }

      return (0, _styledComponents.css)(["padding-left:", "px;"], _designTokens.spacing.base * 3 + 42);
    }

    return '';
  }));
}

var Overlay = _styledComponents.default.div.withConfig({
  displayName: "components__Overlay",
  componentId: "zcog99-0"
})(["background:", ";bottom:0;left:0;position:fixed;right:0;top:0;", ";"], (0, _toColorString.default)(_designTokens.color.opacity.charcoal75), (0, _dynamicModifiers.applyDynamicModifiers)('zIndex', 'z-index'));

exports.Overlay = Overlay;

var Body = _styledComponents.default.div.withConfig({
  displayName: "components__Body",
  componentId: "zcog99-1"
})(["background:", ";border-radius:2px;box-shadow:0 1px 4px ", ";margin:40px auto;max-height:calc(100% - 80px);max-width:650px;overflow:hidden;padding-bottom:75px;position:relative;width:100%;", ";"], (0, _toColorString.default)(_designTokens.color.base.snowWhite), (0, _toColorString.default)(_designTokens.color.shadow.light.default), (0, _styleModifiers.when)('size', _breakpointObserver.sizes.XS, (0, _styledComponents.css)(["border-radius:0;bottom:0;left:0;margin:0;max-height:100%;overflow:hidden;position:fixed;right:0;top:0;"])));

exports.Body = Body;

var ScrollYBox = _styledComponents.default.div.withConfig({
  displayName: "components__ScrollYBox",
  componentId: "zcog99-2"
})(["overflow-y:auto;position:relative;height:100%;max-height:calc(100vh - 150px);", ";"], (0, _styleModifiers.when)('size', _breakpointObserver.sizes.XS, (0, _styledComponents.css)(["max-height:calc(100vh - 70px);"])));

exports.ScrollYBox = ScrollYBox;
var Header = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "components__Header",
  componentId: "zcog99-3"
})([""]);
exports.Header = Header;

var CloseButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "components__CloseButtonContainer",
  componentId: "zcog99-4"
})(["position:absolute;right:15px;top:15px;"]);

exports.CloseButtonContainer = CloseButtonContainer;
var Content = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "components__Content",
  componentId: "zcog99-5"
})(["flex:1;flex-direction:row;", ";"], withIcon());
exports.Content = Content;
var Footer = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "components__Footer",
  componentId: "zcog99-6"
})(["background-color:", ";border-radius:0 0 2px 2px;border-top:1px solid ", ";bottom:0;left:0;position:absolute;right:0;", ";", ";"], (0, _toColorString.default)(_designTokens.color.base.fullMoon), (0, _toColorString.default)(_designTokens.color.opacity.charcoal15), withIcon(), (0, _styleModifiers.when)('size', _breakpointObserver.sizes.XS, (0, _styledComponents.css)(["border-radius:0;"])));
exports.Footer = Footer;